// lib/onesignal.ts
import OneSignal from "react-onesignal";
import configs from "./configs";

let initPromise: Promise<void> | null = null;
let initialized = false;

export function initOneSignal() {
  if (initialized) return Promise.resolve();
  if (initPromise) return initPromise;

  initPromise = (async () => {
    try {
      await OneSignal.init({
        appId: configs.ONESIGNAL_APP_ID,
        serviceWorkerPath: "onesignal/OneSignalSDKWorker.js",
        serviceWorkerParam: { scope: "/onesignal/" },
      });
      initialized = true; // mark success
    } catch (e) {
      console.error(e);
      initialized = false; // allow retry on next call
      throw e;
    } finally {
      initPromise = null; // free the promise reference
    }
  })();

  return initPromise;
}
